import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateGroup = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Group'
      fields={fields}
      apiPath='admin/groups'
      successRedirectPath={resource => `/write-now/groups/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateGroup
